import { types, getParent, onSnapshot } from 'mobx-state-tree'

// These need to be lowercase for route matching
const WHITELISTED_ROUTES = [
  '/traffic-tickets',
  '/traffic/lookup',
]

export const IntercomStore = types
  .model('IntercomStore', {
    enabledRoute: false
  })
  .views(self => ({
    get enabled() {
      if (!process.env.INTERCOM_APP_ID) return false
      return self.enabledRoute
    },
    get user() {
      const { auth } = getParent(self)
      if (!auth.isLoggedIn) return {}
      return {
        user_id: auth.user.objectId,
        email: auth.user.email,
        name: auth.user.name,
        phone: auth.user.phoneNumber,
        created_at: auth.user.createdAt
      }
    }
  }))
  .actions(self => ({
    startIntercomAgent: () => {
      if (!process.env.INTERCOM_APP_ID) return false
      const appStore = getParent(self)
      // run gatekeeper on every route change
      onSnapshot(appStore.router, self.gateKeeper)
      // run gatekeeper to initialize
      self.gateKeeper(appStore.router)
      return true
    },
    gateKeeper(routerStore) {
      // check if new route is whitelisted
      if (WHITELISTED_ROUTES.includes(routerStore.route.toLowerCase())) {
        self.bootUp()
      } else {
        self.teardown()
      }
    },
    // toggles on a component in _app
    bootUp() {
      if (self.enabledRoute) return true
      self.enabledRoute = true
      return true
    },
    // toggles off a component in _app
    teardown() {
      if (!self.enabledRoute) return true
      self.enabledRoute = false
      return true
    }
  }))
